export default __webpack_public_path__ + "static/media/Petideal Creamy Chicken & Scallo.591f2064.png";